/* unplugin-vue-components disabled */import script from "./CornerMark.vue?vue&type=script&setup=true&lang=ts"
export * from "./CornerMark.vue?vue&type=script&setup=true&lang=ts"

import "./CornerMark.vue?vue&type=style&index=0&id=7495ff46&scoped=true&lang=css"

import exportComponent from "/layers/paketo-buildpacks_npm-install/build-modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7495ff46"]])

export default __exports__